import React from 'react';
import { DefaultRouteRedirect } from '@shapegames/core/dist/src/packages/generics/Redirect';

export default function Index() {
  return <DefaultRouteRedirect />;
}
